module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori@3x-c5fedca3ceebf464512fb9c03a39f0db.webp";